import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8 max-w-2xl mx-auto" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Content", -1)
const _hoisted_4 = { class: "text-2xl font-extrabold text-[#1E2833]" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center py-20"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 rounded-full border-4 border-[#6CC551] border-t-transparent animate-spin" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "bg-white rounded-2xl border border-gray-100 overflow-hidden"
}
const _hoisted_9 = { class: "px-8 py-5 border-b border-gray-100 flex items-center gap-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-9 h-9 rounded-xl bg-[#6CC551]/10 flex items-center justify-center flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-5 h-5 text-[#6CC551]",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    })
  ])
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-semibold text-[#1E2833]" }, "Post Details", -1)
const _hoisted_12 = { class: "text-xs text-gray-500" }
const _hoisted_13 = { class: "p-8 space-y-6" }
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1.5 text-xs font-semibold text-gray-600" }, [
  /*#__PURE__*/_createTextVNode("Description "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-400" }, "*")
], -1)
const _hoisted_16 = { class: "h-64" }
const _hoisted_17 = { class: "text-left mt-16" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "post-category",
  class: "block mb-1.5 text-xs font-semibold text-gray-600"
}, "Category", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Select Category", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("option", null, "NEWS", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", null, "GALLERY", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", null, "EVENTS", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", null, "ONGOING PROJECT", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", null, "FINISHED PROJECT", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", null, "UPCOMING PROJECT", -1)
const _hoisted_26 = [
  _hoisted_19,
  _hoisted_20,
  _hoisted_21,
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "px-8 py-5 border-t border-gray-100 bg-gray-50/50" }

import { initTooltips } from "flowbite";
import { QuillEditor } from '@vueup/vue-quill';
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import { computed, onMounted, reactive, ref } from "vue";
import axios from 'axios';
import { decodeEntities } from "@/functions";
import { decryptString } from '@/functions/encryption';
import { url } from "@/functions/endpoint";
import { useRoute, useRouter } from "vue-router";
import Loader from "@/components/Loader.vue";
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Button from "@/components/Inputs/Button.vue"
import InputField from "@/components/Inputs/InputField.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewPost',
  setup(__props) {

onMounted(() => {
  initTooltips();

  getPostDetails()
});

const postInfo = ref([]);

const getPostDetails = async () => {
  if (postId.value !== undefined) {
    isEditing.value = true;
    if (isEditing.value) {
      try {
        const response = await axios.get(`${url}/posts/${parseInt(postId.value)}`);
        const postData = response.data;
        postInfo.value = postData
        createPostData.title = postData.title;
        createPostData.article = decodeEntities(postData.article);
        createPostData.image = postData.image;
        createPostData.category = postData.category.toUpperCase();
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log('creating');
    }
  }
}

const isEditing = ref(false)
const route = useRoute();
const postId = computed(() => decryptString(route.params.id.toString()));
const router = useRouter();

const uploading = ref(false);
let successMessage = ref('');
let showSuccessMessage = ref(false);
let errorAlert = ref(false);
let errorMessage = ref('');

const createPostData = reactive({
  title: "",
  article: "",
  image: null,
  category: "NEWS",
  eventDate: ""
});

const handleImageChange = async (event: any) => {
  const file = event.target.files[0];

  if (file) {
    const formData = new FormData();
    formData.append('file', file);

    try {
      uploading.value = true;
      showSuccessMessage.value = true;
      const response = await axios.post(`${url}/upload`, formData);
      createPostData.image = response.data.url;
      uploading.value = false;
      setTimeout(() => {
        showSuccessMessage.value = false;
      }, 1000)
      successMessage.value = isEditing.value ? 'New image uploaded successfully!' : 'Image uploaded successfully!';
    } catch (error: any) {
      uploading.value = false;
      errorAlert.value = true;
      setTimeout(() => {
        errorAlert.value = false;
      }, 1500)
      errorMessage.value = error?.message;
    }
  }
};


const savePost = async () => {
  uploading.value = true;

  try {
    const postData = {
      title: createPostData.title,
      article: createPostData.article,
      category: createPostData.category,
      image: createPostData.image
    };

    const eventPostData = {
      title: createPostData.title,
      article: createPostData.article,
      image: createPostData.image,
      eventDate: createPostData.eventDate
    };

    if (createPostData.image && typeof createPostData.image !== 'string') {
      const response = await axios.post(`${url}/upload`, { image: createPostData.image });
      postData.image = response.data;
    }

    const methodName = isEditing.value ? "patch" : "post";

    const endpoint = isEditing.value
      ? createPostData.category === "EVENTS"
        ? `${url}/events/update/eventt`
        : `${url}/posts/update/${parseInt(postId.value)}`
      : createPostData.category === "EVENTS"
        ? `${url}/events/create/event`
        : `${url}/posts/create/post`;

    await axios[methodName](endpoint, createPostData.category === "EVENTS" ? eventPostData : postData);

    createPostData.title = '';
    createPostData.article = '';
    createPostData.image = null;
    createPostData.category = '';
    uploading.value = false;
    setTimeout(() => {
      showSuccessMessage.value = true;
    }, 1000)
    successMessage.value = isEditing.value ? 'Post updated successfully!' : 'Post created successfully!';

    setTimeout(() => {
      showSuccessMessage.value = false;

      if (isEditing.value) {
        router.push('/admin/view-posts');
      } else {
        window.location.href = "new-post"
      }
    }, 2000);

  } catch (error: any) {
    uploading.value = false;
    setTimeout(() => {
      errorAlert.value = true;
    }, 1500)
    errorMessage.value = error.message;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("h1", _hoisted_4, _toDisplayString(isEditing.value ? "Edit Post" : "New Post"), 1)
      ]),
      (isEditing.value && postInfo.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", null, [
                _hoisted_11,
                _createElementVNode("p", _hoisted_12, "Fill in the information below to " + _toDisplayString(isEditing.value ? 'update the' : 'create a new') + " post", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(InputField, {
                label: "Title",
                id: "title",
                type: "text",
                placeholder: "Enter post title",
                isRequired: true,
                modelValue: createPostData.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((createPostData.title) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(QuillEditor), {
                    content: createPostData.article,
                    "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => ((createPostData.article) = $event)),
                    contentType: "html",
                    theme: "snow"
                  }, null, 8, ["content"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("select", {
                  id: "post-category",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((createPostData.category) = $event)),
                  class: "w-full px-4 py-2.5 text-sm text-gray-800 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#6CC551]/30 focus:border-[#6CC551] transition-colors"
                }, _hoisted_26, 512), [
                  [_vModelSelect, createPostData.category]
                ])
              ]),
              (createPostData.category === 'EVENTS')
                ? (_openBlock(), _createBlock(InputField, {
                    key: 0,
                    label: "Event date",
                    id: "event-date",
                    type: "date",
                    placeholder: "Enter event date",
                    isRequired: true,
                    modelValue: createPostData.eventDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((createPostData.eventDate) = $event))
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true),
              _createVNode(InputField, {
                label: "Upload image",
                id: "post-image",
                type: "file",
                isRequired: false,
                onChange: handleImageChange
              })
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(Button, {
                buttonText: isEditing.value ? 'Update Post' : 'Publish Post',
                isDisabled: createPostData.title === '' || createPostData.article === '' || !createPostData.image || createPostData.category === '' || uploading.value,
                uploading: uploading.value,
                handleClick: savePost
              }, null, 8, ["buttonText", "isDisabled", "uploading"])
            ])
          ]))
    ]),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})